/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import deleteButton from '../../../assets/images/delete-button.png';

const Delete = ({ handleClick, btnClass }) => (
  <div className="btn-component-div">
    <button type="button" className="btn btn-link" onClick={handleClick}>
      <img
        src={deleteButton}
        className={`btn-delete ${btnClass}`}
        alt="delete"
      />
    </button>
  </div>
);

Delete.propTypes = {
  handleClick: PropTypes.func,
  btnClass: PropTypes.string
};

export default Delete;
